"use client";

import { useEffect } from "react";
import { useSearchParams } from "next/navigation";

import { removeCookie, setCookie } from "@/services/CookiesService";
import { isStripeProviderIdentifier } from "@/internals/constants/psp";
import { isProductionEnv } from "@/utils/environment";
import { ProviderIdentifier } from "@/services/ProviderCookie";
import { MID_COOKIE } from "@/internals/constants/cookies";

export const StoreMid = () => {
  const searchParams = useSearchParams();

  useEffect(() => {
    const pspParam = searchParams.get("psp");
    const psp = pspParam ? pspParam.toLowerCase() : null;
    const midParam = searchParams.get("mid");
    const mid = midParam?.trim();

    const isStripePsp = isStripeProviderIdentifier(psp as ProviderIdentifier);

    // Switching away from a Stripe-family PSP drops any stale mid cookie
    // (defense-in-depth; resolution-time gating keeps the server safe too).
    if (psp !== null && !isStripePsp) {
      removeCookie(MID_COOKIE);
    }

    if (isProductionEnv() || !isStripePsp || !mid) return;

    // MID ids are case-sensitive: store the value unmodified apart from trimming.
    setCookie(MID_COOKIE, mid);
  }, [searchParams]);

  return null;
};
